(function () {
  if (!document.body.classList.contains("is-home")) return;

  const overlay = () => document.getElementById("page-overlay");
  const footer = () =>
    document.getElementById("shopify-section-footer-group") ||
    document.getElementById("shopify-section-footer") ||
    document.querySelector("footer");

  const hasCarousel = () => document.querySelector(".crf-wrap");

  function apply() {
    const o = overlay();
    const f = footer();
    if (!o || !f) return;

    const h = Math.ceil(f.getBoundingClientRect().height);
    document.documentElement.style.setProperty("--footer-reveal-h", h + "px");

    // If the carousel exists, it will handle the reveal space itself
    if (hasCarousel()) {
      o.style.paddingBottom = "0px";
    } else {
      // No carousel: use classic footer-reveal padding
      o.style.paddingBottom = h + "px";
    }
  }

  document.addEventListener("DOMContentLoaded", apply);
  window.addEventListener("load", apply);

  const ro = new ResizeObserver(() => apply());
  window.addEventListener("load", () => {
    const f = footer();
    if (f) ro.observe(f);
  });

  window.addEventListener("resize", () => apply());
})();
